import { isAnalyticsAllowed, clearAnalyticsCookies } from './cookie-consent';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let ga4Loaded = false;
const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || '';

/** Load GA4 script if consent is given and env var is set */
export function loadGA4IfAllowed(): void {
  if (!GA_ID || GA_ID.includes('VITE_GA')) return;
  if (ga4Loaded) return;
  if (!isAnalyticsAllowed()) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(...args: unknown[]) {
    window.dataLayer!.push(args);
  }
  gtag('js', new Date());
  gtag('config', GA_ID);
  window.gtag = (...args: unknown[]) => {
    window.dataLayer!.push(args);
  };

  ga4Loaded = true;
}

/** Remove GA4 when consent is revoked */
export function unloadGA4(): void {
  clearAnalyticsCookies();
  window.gtag = undefined;
  window.dataLayer = undefined;
  ga4Loaded = false;
}
